<template>
  <hr-menu-item
    v-if="lead"
    v-close-popup
    :icon="lead.icon"
    :label="actionLabel(lead, count)"
    :aria-label="lead.ariaLabel"
    :disable="lead.disable"
    :data-e2e="lead.dataE2e"
    @click="lead.handler"
  />
  <hr-item-label
    v-if="heading"
    header
  >
    {{ heading }}
  </hr-item-label>
  <template
    v-for="path in paths"
    :key="path.key"
  >
    <!--
      A group is a label and nothing else: it runs nothing itself, so it expands rather than
      acting. One level only, because a second would be a navigation tree rather than a list of
      ways to make a record.
    -->
    <hr-menu-group
      v-if="path.paths"
      :label="actionLabel(path, count)"
      :icon="path.icon"
      :disable="path.disable"
      :data-e2e="path.dataE2e"
    >
      <hr-menu-item
        v-for="child in path.paths"
        :key="child.key"
        v-close-popup
        :icon="child.icon"
        :label="actionLabel(child, count)"
        :aria-label="child.ariaLabel"
        :disable="child.disable"
        :data-e2e="child.dataE2e"
        @click="child.handler"
      />
    </hr-menu-group>
    <hr-menu-item
      v-else
      v-close-popup
      :icon="path.icon"
      :label="actionLabel(path, count)"
      :aria-label="path.ariaLabel"
      :disable="path.disable"
      :data-e2e="path.dataE2e"
      @click="path.handler"
    />
  </template>
</template>

<script>
import { HrItemLabel, HrMenuGroup, HrMenuItem } from 'src/design-system';

import { actionLabel } from 'components/UI/recordActions';

/**
 * The creation paths behind a create control, as a flat list or one level of named groups.
 *
 * Its own component because the same list is rendered twice — behind the split button at an
 * expanded width and inside the FAB's menu at a phone width — and a grouped list is too much to
 * keep in step by hand in two places.
 */
export default {
  name: 'RecordsCreateMenu',

  components: { HrItemLabel, HrMenuGroup, HrMenuItem },

  props: {
    /**
     * The paths, in rank order. An entry carrying `paths` is a group and runs nothing itself.
     * @type {import('components/UI/recordActions').RecordAction[]}
     */
    paths: { type: Array, required: true },
    /**
     * A path listed ahead of the heading, apart from the paths it names: the primary action, where
     * the FAB opens this menu rather than running it.
     * @type {import('components/UI/recordActions').RecordAction}
     */
    lead: { type: Object, default: null },
    /** What the paths have in common, as a label above them. */
    heading: { type: String, default: null },
    /** Records the labels count against, for a path whose label is a function. */
    count: { type: Number, default: 0 },
  },

  methods: { actionLabel },
};
</script>
